import React from 'react';
import { IconButton } from '@mui/material';

import BurgerMenuIcon from '../../icons/BurgerMenuIcon';
import CloseIcon from '../../icons/CloseIcon';

import { StyledHeaderBurgerMenu } from './Header.styled';

function HeaderBurgerMenu(props) {
  const { isOpen, toggleNavMenu, isCustomerLoading } = props;

  const handleToggle = () => {
    if (!isCustomerLoading) {
      toggleNavMenu();
    }
  };

  return (
    <StyledHeaderBurgerMenu>
      <IconButton
        size={isOpen ? 'small' : 'medium'}
        onClick={handleToggle}
        aria-label="Mobile Menu"
        disabled={isCustomerLoading}
      >
        {isOpen ? <CloseIcon /> : <BurgerMenuIcon />}
      </IconButton>
    </StyledHeaderBurgerMenu>
  );
}

export default HeaderBurgerMenu;
